export default {
  doSave () {
    this.$v.$touch()
    if (this.$v.$error) {
      return
    }
    const item = this.prepareSave({...this[this.entity]})

    if (!this.beforeSave(item)) {
      return
    }

    this.$resource.save(item)
      .then((data) => {
        if (data.id) {
          this.errors = {}
          const after = this.isCreate ? 'Created' : 'Updated'
          this['after' + after](data, item)
          this.book_occurrence.book = data.id
          this.seeUploadImage = true
        }
      })
      .catch((er) => {
        this.errors = er.data
        this.afterFailure(er)
      })
  },
  afterCreated () {
    this.$toast.success('Ocorrência incluida com sucesso!')
  },
  afterUpdated () {
    this.$toast.success('Ocorrência alterada com sucesso!')
  },
  doClear () {
    this.occurrence.content = null
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  onUploadedOccurrenceImg (response) {
    if (!response) {
      return
    }
    const occurrence = {...response}
    this.occurrence.img = occurrence.book.image + '?' + new Date()
    return this.$router.push({name: 'dweller.book.occurrence.index'})
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/book-occurrence/form/resources/methods.js